// extracted by mini-css-extract-plugin
export var legendIndicator = "_8q-1";
export var legendRight = "_8q-0";